import { BaseState, AttachedFile } from "@base/entities/BaseEntities";
import { BaseComponent } from "@base/component/BaseComponent";
import { Component, Input, Output, EventEmitter, ViewChild } from "@angular/core";
import { ServiceBagService } from "@base/component/ServiceBag";
import { Utils } from "@core/helpers/Utils";
import { ImageBoxDialogComponent } from '@ui/dialogs/imagebox-dialog/imageboxdialog.component';

class State extends BaseState {
    ImageSource: string;
}

@Component({
    selector: 'm4u-filecard',
    templateUrl: './file-card.component.html',
    styleUrls: ['./file-card.component.scss']
})
export class FileCardComponent extends BaseComponent<State>
{
    @Input() Entity: AttachedFile;
    @Input() AllowDownload: boolean = true;
    @Input() Disabled = false;
    @Output() DeleteItem = new EventEmitter();
    @Output() DownloadItem = new EventEmitter();

    @ViewChild(ImageBoxDialogComponent) imageDialog: ImageBoxDialogComponent;

    constructor(A: ServiceBagService) {
        super(A, "FileCardComponent", State);
    }

    override OnInitComponent() {

        if (this.Entity.IsDisplayedAsImage) {
            Utils.LoadFilesBody([this.Entity.NewFile], (uploadFiles) => {
                const file = uploadFiles[0];
                this.State.ImageSource = Utils.GetImageSource(file.Data, this.Entity.NewFile.type);
            });
        }
    }

    OnImageClick() {
        if (!this.Entity?.IsDisplayedAsImage) {
            return;
        }

        this.imageDialog.ImageSource = this.State.ImageSource;
        this.imageDialog.ShowDialogShort(() => { });
    }

    OnCloseClick() {
        this.imageDialog.CloseDialogWithSuccess();
    }

    OnDeleteItem() {
        this.DeleteItem.emit(this.Entity);
    }

    OnDownloadItem() {
        this.DownloadItem.emit(this.Entity);
    }

    OnClose() {
        this.NavigateBack();
    }
}
